import RemotingService from "../remoting-service/RemotingService";
import {noop} from "lodash-es";

class LookupService {

    getNationalities(callback) {
        RemotingService.getRemoteCall('api/public/lookup/nationalities', null, (nationalities) => {
            callback(nationalities);
        }, noop, false);
    }

    getCountries(callback) {
        RemotingService.getRemoteCall('api/public/lookup/countries', null, (countries) => {
            callback(countries);
        }, noop, false);
    }

    getLanguages(callback) {
        RemotingService.getRemoteCall('api/public/lookup/languages', null, (languages) => {
            callback(languages);
        }, noop, false);
    }

    getReligions(callback) {
        RemotingService.getRemoteCall('api/public/lookup/religions', null, (religions) => {
            callback(religions);
        }, noop, false);
    }

    getMaritalStatuses(callback) {
        RemotingService.getRemoteCall('api/public/lookup/marital-statuses', null, (maritalStatuses) => {
            callback(maritalStatuses);
        }, noop, false);
    }

    getProfessions(callback) {
        RemotingService.getRemoteCall('api/public/lookup/professions', null, (professions) => {
            callback(professions);
        }, noop, false);
    }

    getRelationshipTypes(callback) {
        RemotingService.getRemoteCall('api/public/lookup/relationship-types', null, (relationshipTypes) => {
            callback(relationshipTypes);
        }, noop, false);
    }

    getAllergyTypes(callback) {
        RemotingService.getRemoteCall('api/public/lookup/allergy-types', null, (allergyTypes) => {
            callback(allergyTypes);
        }, noop, false);
    }

    getAllergenTypes(callback) {
        RemotingService.getRemoteCall('api/public/lookup/allergen-types', null, (allergenTypes) => {
            callback(allergenTypes);
        }, noop, false);
    }

    getAllergenReactionTypes(callback) {
        RemotingService.getRemoteCall('api/public/lookup/allergen-reaction-types', null, (reactionTypes) => {
            callback(reactionTypes);
        }, noop, false);
    }

    getAllergySeverityTypes(callback) {
        RemotingService.getRemoteCall('api/public/lookup/allergy-severity-types', null, (severityTypes) => {
            callback(severityTypes);
        }, noop, false);
    }

    getGenders(callback) {
        RemotingService.getRemoteCall('api/public/lookup/genders', null, (genders) => {
            callback(genders);
        }, noop, false);
    }

    getEducationLevels(callback) {
        RemotingService.getRemoteCall('api/public/lookup/education-levels', null, (educationLevels) => {
            callback(educationLevels);
        }, noop, false);
    }

    getEmploymentStatuses(callback) {
        RemotingService.getRemoteCall('api/public/lookup/employment-statuses', null, (employmentStatuses) => {
            callback(employmentStatuses);
        }, noop, false);
    }

    getSmokingDevices(callback) {
        RemotingService.getRemoteCall('api/public/lookup/smoking-devices', null, (smokingDevices) => {
            callback(smokingDevices);
        }, noop, false);
    }

    getSmokingStatuses(callback) {
        RemotingService.getRemoteCall('api/public/lookup/smoking-statuses', null, (smokingStatuses) => {
            callback(smokingStatuses);
        }, noop, false);
    }

    getDrinkingStatuses(callback) {
        RemotingService.getRemoteCall('api/public/lookup/drinking-statuses', null, (drinkingStatuses) => {
            callback(drinkingStatuses);
        }, noop, false);
    }

    getSubstanceAbuseStatuses(callback) {
        RemotingService.getRemoteCall('api/public/lookup/substance-abuse-statuses', null, (substanceAbuseStatuses) => {
            callback(substanceAbuseStatuses);
        }, noop, false);
    }

    getSubstanceAbuseTypes(callback) {
        RemotingService.getRemoteCall('api/public/lookup/substance-abuse-types', null, (substanceAbuseTypes) => {
            callback(substanceAbuseTypes);
        }, noop, false);
    }

    getMedicationRoutes(callback) {
        RemotingService.getRemoteCall('api/public/lookup/medication-routes', null, (routes) => {
            callback(routes);
        }, noop, false);
    }

    getMedicationUnits(callback) {
        RemotingService.getRemoteCall('api/public/lookup/medication-units', null, (routes) => {
            callback(routes);
        }, noop, false);
    }

    searchClinicalFindingSnomedCodes = (inputValue, callback, minimumSearchLength = 2) => {
        if (inputValue.length < minimumSearchLength) {
            return callback(null);
        }
        RemotingService.getRemoteCall('api/snomed/clinical-findings?key=' + inputValue, null,
            (response) => callback(response == null || response.length === 0 ? null : response)
        );
    }

    searchFamilyHistorySnomedCodes = (inputValue, callback, minimumSearchLength = 2) => {
        if (inputValue.length < minimumSearchLength) {
            return callback(null);
        }
        RemotingService.getRemoteCall('api/snomed/family-history?key=' + inputValue, null,
            (response) => callback(response == null || response.length === 0 ? null : response)
        );
    }

    /**
     * Matches a lookup value to the correct object from the options array.
     * Required for SelectInput components with displayProperty - they need exact object reference from Redux store.
     *
     * @param {*} value - The value to match (can be object with id, or primitive id/key/name)
     * @param {Array} options - Array of lookup objects from Redux store (e.g., relationshipTypes, nationalities)
     * @returns {Object|null} - Matched object from options array, or null if not found
     */
    matchLookupObject(value, options) {
        if (!value || !options || !Array.isArray(options)) {
            return null;
        }

        if (typeof value === 'object') {
            return options.find(option => option.id === value.id) || null;
        }

        return options.find(option =>
            option.id === value || option.key === value || option.name === value
        ) || null;
    }
}

export default new LookupService();
